var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saturnalia-map-wrapper"},[_c('iframe',{staticClass:"sat-iframe",attrs:{"frameBorder":"0","id":"output-frame-id"}})])
}]

export { render, staticRenderFns }